import React, { useEffect, useState, useCallback, useRef } from "react";
import { Dropdown, Modal, Button, Tabs, Tab, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Spinner from "../components/Common/Spinner";
import {
  addFile,
  createNewAdmin,
  deleteAdmin,

  getUrl,
  updateAdminInfo,
  updateAdminStatus,
  verifyUser,
 
} from "../../services/Admin/adminServices";
import Pagination from "../components/Pagination";
import { useFetcher, useNavigate, useLocation } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getContactUs, getUserList, getWaitList } from "../../services/UserServices/UserService";

const ReadMoreText = ({ text, maxLength = 30, maxWidth = "250px" }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return "_";

  const textStr = typeof text === "string" ? text : String(text);
  const formattedText = textStr.charAt(0).toUpperCase() + textStr.slice(1);

  if (formattedText.length <= maxLength) {
    return <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{formattedText}</span>;
  }

  return (
    <div style={{ maxWidth: isExpanded ? "400px" : maxWidth, wordBreak: "break-word", whiteSpace: "normal" }}>
      {isExpanded ? formattedText : `${formattedText.slice(0, maxLength)}...`}
      <button
        type="button"
        className="btn btn-link p-0 text-primary fw-semibold ms-1"
        style={{ fontSize: "12px", textDecoration: "none", boxShadow: "none", verticalAlign: "baseline" }}
        onClick={(e) => {
          e.stopPropagation();
          setIsExpanded(!isExpanded);
        }}
      >
        {isExpanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
};

const ContactList = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage ?? 0
  );
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "User"
  );
  const [type, setType] = useState("");
 
  const [confirmState, setConfirmState] = useState({
    show: false,
    action: null,
    id: null,
    status: null,
    message: "",
  });
 const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState("");
  const fileInputRef = useRef(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const fetchAdmins = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getContactUs(
        currentPage,
        itemsPerPage,
     
        debouncedSearch
      );
      setAdmins(response?.data?.data?.data || []);
      setTotalItems(response?.data?.data?.total || 0);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  }, [
    currentPage,
    itemsPerPage,
    debouncedSearch,
    
  ]);

  useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [search]);

  

  useEffect(() => {
    if (currentPage !== undefined) {
      navigate(".", {
        replace: true,
        state: { ...location.state, currentPage, activeTab },
      });
    }
  }, [currentPage, activeTab]);

  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    setCurrentPage(0);
  }, [debouncedSearch, type]);

  const activeTabMount = useRef(true);
  useEffect(() => {
    if (activeTabMount.current) {
      activeTabMount.current = false;
      return;
    }
    setSearch("");
    setCurrentPage(0);
    setStartDate("");
    setEndDate("");
    setType("");
  }, [activeTab]);

  const getUrlImage = async (img) => {
    try {
      return await getUrl(img);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteAdmin(id);
      toast.success("Successfully deleted");
      fetchAdmins();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to delete user");
      console.error(error);
    }
  };

  const handlestatus = async (id) => {
    try {
      const payload = { userId: id };
      await updateAdminStatus(payload);
      toast.success("Status updated successfully");
      fetchAdmins();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update status");
      console.error(error);
    }
  };

  const handleFileUpload = async (e, fieldName, setFieldValue) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", file);
      const res = await addFile(formData);

      if (res) {
        setPreview(URL.createObjectURL(file));
        setFieldValue("image", res?.data?.data?.fileUrl);
      }
    } catch (error) {
      toast.error("File upload failed");
      setPreview("");
    } finally {
      setUploading(false);
    }
  };

  const openModal = async (admin = null) => {
    setSelectedAdmin(admin);
    setShowModal(true);

    if (admin?.image) {
      try {
        setImageLoading(true);
        const res = await getUrlImage(admin.image);
        setPreview(res?.data?.data);
      } catch (error) {
        console.error(error);
      } finally {
        setImageLoading(false);
      }
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedAdmin(null);
    setPreview("");

    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const AdminSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    image: Yup.string().required("image is required"),
  });

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setSubmit(true);
      if (selectedAdmin) {
        const payload = {
          id: selectedAdmin._id,
          name: values.name,
          image: values.image,
        };
        await updateAdminInfo(payload);
        toast.success("Updated successfully");
      } else {
        await createNewAdmin(values);
        toast.success("Added successfully");
        resetForm();
      }
      fetchAdmins();
      setShowModal(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to save admin");
    } finally {
      setSubmit(false);
    }
  };

 

  const isFilterActive = search || startDate || endDate || type;

  const handleRequest = async (status, id) => {
    try {

      const payload = {
        id: id,
        status: status,
      };
      await verifyUser(payload)
      toast.success(`Request Successfully Verified`);
      fetchAdmins();
    } catch (error) {
      console.error(error);
    }
  };

  const handleClear = () => {
    setSearch("");
    setStartDate("");
    setEndDate("");
    setType("");
  };

  // 🌟 Trigger Confirmation Modal
  const triggerConfirm = (action, id, status = null) => {
    let message = "";
    if (action === "delete") {
      message =
        "Are you sure you want to delete this record? This action cannot be undone.";
    } else if (action === "status") {
      message = `Are you sure you want to ${status.toLowerCase()} this account?`;
    } else if (action === "Verified") {
      message = `Are you sure you want to verify this user's request?`;
    }
    else if (action === "Reject") {
      message = `Are you sure you want to reject this user's request?`;
    }

    setConfirmState({ show: true, action, id, status, message });
  };

  // 🌟 Execute Action After Confirmation
  const confirmActionHandler = () => {
    const { action, id, status } = confirmState;
    if (action === "delete") {
      handleDelete(id);
    } else if (action === "status") {
      handlestatus(id);
    } else if (action === "Verified") {
      handleRequest("Verified", id);
    }
    else if (action === "Reject") {
      handleRequest("Reject", id);
    }

    setConfirmState({
      show: false,
      action: null,
      id: null,
      status: null,
      message: "",
    });
  };

const handleExportCSV = () => {
  if (!admins || admins.length === 0) {
    toast.error("No data available to export");
    return;
  }

  const csvData = admins.map((admin, index) => ({
    "Sr No": currentPage * itemsPerPage + index + 1,
    Name: admin.name || "",
    Email: admin.email || "",
    Phone: admin.phoneNumber
      ? `${admin.countryCode || ""} ${admin.phoneNumber}`
      : "",
    Address: admin.address || "",
    Status:
      admin.adminApprove === "Verified"
        ? admin.isBlocked
          ? "Disabled"
          : "Enabled"
        : "",
    Verification: admin.adminApprove || "",
    "Created At": admin.createdAt
      ? `${new Date(admin.createdAt).toLocaleDateString("en-CA", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })} ${new Date(admin.createdAt).toLocaleTimeString("en-CA", {
          hour: "2-digit",
          minute: "2-digit",
        })}`
      : "",
  }));

  const headers = Object.keys(csvData[0]);

  const csvContent = [
    headers.join(","),
    ...csvData.map((row) =>
      headers
        .map((header) =>
          `"${String(row[header] ?? "").replace(/"/g, '""')}"`
        )
        .join(",")
    ),
  ].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.setAttribute(
    "download",
    `users_${new Date().toISOString().split("T")[0]}.csv`
  );

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);

  toast.success("CSV exported successfully");
};
 


  return (
    <div className="container mt-4">
   <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 style={{ color: "#E5484D" }}>Contact Us</h1>
        
      </div>




      <div className="pb-2 d-flex flex-wrap justify-content-between gap-2 align-items-end mb-4">
        <div className="flex-grow-1">
          <label className="form-label mb-1" style={{ fontSize: "12px", color: "#6c757d" }}>
            Search
          </label>
          <input
            type="text"
            style={{ borderRadius: "0.5rem", borderColor: "#E5484D", height: "42px" }}
            className="form-control w-100"
            placeholder="Search by name, email....."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {isFilterActive && (
          <div>
            <button
              className="btn btn-outline-danger"
              onClick={handleClear}
              style={{ borderRadius: "0.5rem", height: "42px" }}
            >
              Clear
            </button>
          </div>
        )}
      </div>

  
          {loading ? (
            <Spinner />
          ) : (
            <div className="table-responsive">
              <table className="table table-striped align-middle shadow-sm">
                <thead className="table-light">
                  <tr>
                    <th>Sr No.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Subject</th>
                    <th>Message</th>
                    <th>Inquiry Date</th>
                  
                     
                    {/* <th>Action</th> */}
                   
                    {/* <th style={{ textAlign: "center" }}>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {admins?.length > 0 ? (
                    admins.map((admin, index) => (
                      <tr key={admin._id || index}>
                        <td>{currentPage * itemsPerPage + index + 1}</td>
                        <td>
                          {admin.name
                            ? `${admin.name
                                .charAt(0)
                                .toUpperCase()}${admin.name.slice(1)}`
                            : "_"}
                        </td>
                        <td>{admin.email ? admin.email : "_"}</td>
                        <td>
                          <ReadMoreText text={admin.subject} maxLength={25} maxWidth="200px" />
                        </td>
                        <td>
                          <ReadMoreText text={admin.description} maxLength={35} maxWidth="300px" />
                        </td>
                        <td>
                          {new Date(admin.createdAt).toLocaleDateString(
                            "en-CA",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            },
                          )}
                          {", "}
                          {new Date(admin.createdAt).toLocaleTimeString(
                            "en-CA",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                            },
                          )}
                        </td>
   {/* {admin.adminApprove === "Verified" ?
    <td>
                          <span
                            className={`badge ${
                              admin.isBlocked ? "bg-danger" : "bg-success"
                            }`}
                          >
                            {admin.isBlocked ? "Disabled" : "Enabled"}
                          </span>
                        </td> : <td>_</td>} */}


                         {/* <td>
                          {admin.adminApprove }   
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              id={`dropdown-basic-${index}`}
                              style={{ padding: "4px 8px" }}
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
  <Dropdown.Item
                                onClick={() =>
                                  navigate(`/user-detail/${admin._id}`)
                                }
                              >
                                View
                              </Dropdown.Item>

                     { admin?.adminApprove === "Verified" ?   <Dropdown.Item
                                onClick={() =>
                                  triggerConfirm(
                                    "status",
                                    admin._id,
                                    admin.isBlocked ? "Enable" : "Disable",
                                  )
                                }
                              >
                                {admin.isBlocked ? "Enable" : "Disable"}
                              </Dropdown.Item> : ""}

{ admin?.adminApprove === "Verified" ? "":
<>
 <Dropdown.Item
                                onClick={() =>
                                  triggerConfirm(
                                    "Verified",
                                    admin._id,
                                   
                                  )
                                }
                              >
                               Verify 
                              </Dropdown.Item> 
                               <Dropdown.Item
                                onClick={() =>
                                  triggerConfirm(
                                    "Reject",
                                    admin._id,
                                   
                                  )
                                }
                              >
                               Reject 
                              </Dropdown.Item> 
                              </>
                              }

                              <Dropdown.Item
                                onClick={() =>
                                  triggerConfirm("delete", admin._id)
                                }
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No data found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
      

      <div className="card-footer clearfix mt-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
        <div
            className="dataTables_info fw-bold mb-3 mb-md-0"
            style={{ color: "#E5484D" }}
          >Total Contact Us : {totalItems}</div>
          <div className="d-flex align-items-center">
            {totalPages > 0 && (
              <Pagination
                pageCount={totalPages}
                pageValue={currentPage}
                setPage={setCurrentPage}
              />
            )}
          </div>
        </div>
      </div>

      {/* Main Edit/Add Modal */}
      <Modal size="xl" show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedAdmin ? "Edit User" : "Add User"}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={
            selectedAdmin
              ? {
                  userId: selectedAdmin._id,
                  name: selectedAdmin.name || "",
                  image: selectedAdmin.image || "",
                }
              : {
                  name: "",
                  image: "",
                }
          }
          enableReinitialize
          validationSchema={AdminSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, values, setFieldValue }) => (
            <FormikForm>
              <Modal.Body>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <Field
                    name="name"
                    placeholder="ex. John Doe"
                    className={`form-control ${
                      errors.name && touched.name ? "is-invalid" : ""
                    }`}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    ref={fileInputRef}
                    onChange={(e) =>
                      handleFileUpload(e, "image", setFieldValue)
                    }
                  />
                  <ErrorMessage
                    name="image"
                    component="div"
                    className="text-danger mt-1"
                  />
                </div>

                {uploading ? (
                  <div className="text-success mt-2">Uploading image...</div>
                ) : imageLoading ? (
                  <div>loading...</div>
                ) : (
                  preview && (
                    <div className="mb-3 text-center mt-3">
                      <div
                        style={{
                          display: "inline-block",
                          position: "relative",
                        }}
                      >
                        <img
                          src={preview}
                          alt="preview"
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "10px",
                            border: "1px solid #ddd",
                          }}
                        />
                        <button
                          type="button"
                          className="btn btn-danger btn-sm shadow"
                          style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-8px",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            padding: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            lineHeight: "1",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                          onClick={() => {
                            setPreview("");
                            if (fileInputRef.current)
                              fileInputRef.current.value = "";
                            setFieldValue("image", "");
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    </div>
                  )
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Close
                </Button>
                <Button
                  type="submit"
                  style={{ backgroundColor: " #FFE4E6", border: "none" }}
                  disabled={uploading}
                >
                  {submit ? "Saving" : "Save Changes"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>

      {/* 🌟 New Confirmation Modal */}
      <Modal
        show={confirmState.show}
        onHide={() => setConfirmState({ ...confirmState, show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0 fs-5">{confirmState.message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setConfirmState({ ...confirmState, show: false })}
          >
            Cancel
          </Button>
          <Button
            variant={
              confirmState.action === "delete" ||
              confirmState.status === "Reject"
                ? "danger"
                : "primary"
            }
            style={
              confirmState.action !== "delete" &&
              confirmState.status !== "Reject"
                ? {
                    backgroundColor: "#E5484D",
                    borderColor: "#FFE4E6",
                    color: "white",
                  }
                : {}
            }
            onClick={confirmActionHandler}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

   
    </div>
  );
};

export default ContactList;